import React from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import SublimationSizeTable from "./SublimationSizeTable";
import { useDispatch, useSelector } from "react-redux";
import { setSublimationSizeModal } from "../../../API/Reducer/fabricReducer";

const SublimationSizeModal = () => {
  const dispatch = useDispatch();
  const { sublimationSizeModal } = useSelector((state) => state.fabric);
  return (
    <Modal show={sublimationSizeModal} 
    onHide={() => {dispatch(setSublimationSizeModal(false));}}
     size="lg" centered backdrop="static">
      <Modal.Body style={{ position: "relative", padding: "1rem" }}>
        {/* Close Icon */}
        <div
          onClick={() => {dispatch(setSublimationSizeModal(false));}}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            fontSize: "1.2rem",
            color: "#555",
          }}
          title="Close"
        >
          <IoClose />
        </div>

        {/* Table */}
        <SublimationSizeTable />
      </Modal.Body>
    </Modal>
  );
};

export default SublimationSizeModal;
